
import { Component, Prop, Vue } from 'vue-property-decorator';
import { SalesQuote, SalesQuoteClaim } from '@/api';
import Helpers from '@/logic/orders/helpers';

@Component({})
export default class ClaimDetailsCard extends Vue {
  @Prop({ type: Object, required: true })
  claim!: SalesQuoteClaim;

  @Prop({ type: Object, required: true })
  agreement!: SalesQuote;

  @Prop({ type: Boolean, default: true })
  showProfile!: boolean;

  Helpers = Helpers;
}
